'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@common/components';
import { SvgChevronright } from '@common/icon';
import { cn } from '@core/utils';
import { WEL_MARKET_ROUTES } from '@/constants/routes';
import { useCustomRouter } from '@/hooks/useCustomRouter';
export const CartEmptyState = () => {
  const $ = _c(7);
  const {
    push
  } = useCustomRouter();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = cn("flex min-h-[calc(100dvh-6.125rem)] flex-col items-center justify-center gap-24 px-20");
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <p className="text-center font-400 text-Gray-550 typo-body3">아직 담긴 상품이 없어요.<br />마음에 드는 상품을 골라보세요.</p>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== push) {
    t2 = () => push(WEL_MARKET_ROUTES.HOME.pathname);
    $[2] = push;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <SvgChevronright className="size-10 text-Gray-600" />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2) {
    t4 = <div className={t0}>{t1}<Button dimensions="H48" theme="sub-line" onClick={t2} className="gap-6 !rounded-none">상품 보러가기{t3}</Button></div>;
    $[5] = t2;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};